import Client from '../HttpClient';

const list = () => {
	return Client.get('/admin/api/note-group');
};

const find = (code) => {
	return Client.get(`/admin/api/note-group/${code}`);
};

const create = (payload) => {
	return Client.post('/admin/api/note-group', payload);
};

const update = (code, payload) => {
	return Client.put(`/admin/api/note-group/${code}`, payload);
};

const remove = (code) => {
	return Client.del(`/admin/api/note-group/${code}`);
};

export default {
	list,
	find,
	create,
	update,
	remove,
};
